module.exports = __webpack_public_path__ + "img/WAPPR.c2b19cab.svg";